import {createSlice} from '@reduxjs/toolkit';
import {LOADING_STATES, INPUT_SELECTED_ITEM_ID_INDEX, updateWindowLocationHash} from "@Libraries/email-marketing-campaigns-library.js";
import {emailMarketingCampaignPerformanceExtraReducers} from "@Components/email-marketing-campaign-performance/email-marketing-campaign-performance-extra-reducers.js";

const initialState = {
    performanceLoadingState: LOADING_STATES.NOT_LOADED,
    campaigns: [],
    campaignsWithMetricsAvailable: [],
    campaignsWithMetricsNotAvailable: [],
    campaignsWithMetricsCollecting: [],
    mailingLists: [],
    mailingListsWithAvailableMetrics: [],
    mailingListsWithMetricsNotAvailable: [],
    mailingListsWithMetricsCollecting: [],
    campaignMetrics: [],
    mailingListMetrics: [],
    selectedItemIds: [],
    itemType: '',
    isNoCampaignCreated: false,
    isNoCampaignPublished: false,
    isCollectingData: false,
    isNoMailingListCreated: false,
    isNotCollectingData: false
};

const emailCampaignsPerformanceSlice = createSlice({
    name: 'emailCampaignsPerformance',
    initialState,
    reducers: {
        updateItemType: (state, action) => {
            const itemType = action.payload.itemType, selectedItemIds = [];
            state.itemType = itemType;
            state.selectedItemIds = selectedItemIds;
            state.performanceLoadingState = LOADING_STATES.NOT_LOADED;
            updateWindowLocationHash(itemType, selectedItemIds);
        },
        updateFirstId: (state, action) => {
            state.selectedItemIds[INPUT_SELECTED_ITEM_ID_INDEX.FIRST_ID] = action.payload.firstId;
            state.performanceLoadingState = LOADING_STATES.NOT_LOADED;
            updateWindowLocationHash(state.itemType, state.selectedItemIds);
        },
        updateSecondId: (state, action) => {
            state.selectedItemIds[INPUT_SELECTED_ITEM_ID_INDEX.SECOND_ID] = action.payload.secondId;
            state.performanceLoadingState = LOADING_STATES.NOT_LOADED;
            updateWindowLocationHash(state.itemType, state.selectedItemIds);
        },
        updateLoadingState: (state, action) => {
            state.performanceLoadingState = action.payload;
        }
    },
    extraReducers: emailMarketingCampaignPerformanceExtraReducers
});

export const {updateItemType, updateFirstId, updateSecondId, updateLoadingState} = emailCampaignsPerformanceSlice.actions;
export const emailMarketingCampaignsPerformanceReducer = emailCampaignsPerformanceSlice.reducer;

export const resetPerformanceLoadingState = () => {
    PMW.redux.store.dispatch(updateLoadingState(LOADING_STATES.NOT_LOADED));
}
